export const setMeta = seo => {
  document.title = seo.title || 'Fêtes de la Nouvelle-France';
  const metas = document.getElementsByTagName('meta')
  metas["og:title"].content = seo.title || 'Fêtes de la Nouvelle-France'
  metas["description"].content = seo.description || ''
  metas["og:description"].content = seo.description || ''
  metas["og:image"].content = seo.image?.original || '/img/logo.svg'
  metas["og:type"].content = seo.type || 'website'
  metas["twitter:card"].content = seo.twitter || 'summary'
}
